import {decorate, observable} from 'mobx';
import {faScroll} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';
import {superUserPermission} from './permission';

export class Role extends BaseModel {
  static faIcon = faScroll;

  searchableProperties = ['name'];

  get isSuperUserRole() {
    return this.permissionIdentifiers?.includes(superUserPermission);
  }
}

decorate(Role, {
  id: observable,
  name: observable,
  defaultExpireDays: observable,
  defaultAlertBeforeExpireDays: observable,
  permissionIdentifiers: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});
